/**
 * File: googleLogin.api.ts of WeTradeWeb
 * Author: 阿佑[ayooooo@petalmail.com]
 * Date: 2023/9/26 14:53
 */
import requestResult from '@/common/request/request'
import { User } from '@/modules/user/user.api'

export const googleLogin = requestResult<User>('/api/user/google/login')
